/**
 * Utility functions for formatting currency, percentages, and other values
 */

export const formatCurrency = (pennies: number): string => {
  const pounds = pennies / 100;
  return pounds.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatCurrencyWhole = (pennies: number): string => {
  const pounds = pennies / 100;
  return pounds.toLocaleString("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};

export const formatPercentage = (decimal: number): string => {
  return `${(decimal * 100).toFixed(2)}%`;
};

export const formatMultiple = (multiple: number): string => {
  return `${multiple.toFixed(2)}x`;
};

export const formatDateTime = (timestamp: number): string => {
  return new Date(timestamp).toLocaleString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};
